<template>
  <div class="index">
    <div class="index-header">
      <el-form :model="form" :inline="true" label-width="100px">
        <div class="input-box">
          <div>
            <label style="margin:5px 10px 0 30px;">地区：</label>
          </div>
          <div style="margin-bottom:10px">
            <Area :value="area_data" :diss="dis" :arr="arrPlace1" @getPlace="getPlace1"/>
          </div>
          <div>
            <el-form-item label="月份：">
              <el-date-picker style="width:193px;" v-model="form.month" value-format="yyyy-MM" type="month" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button type="primary" @click=" $data.paging_data.pageSize=$data.paging_data.total=1,Filter_file({api:api,data:form,callback:_d=>tableData=_d})" icon="el-icon-search">查询</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="edit">
        <el-button :disabled="selectRow.length==1?false:true" v-if="showBtn[1].isShow" icon="el-icon-edit" @click="openBox('edit')">编辑</el-button>
        <el-button icon="el-icon-edit" v-if="showBtn[3].isShow" @click="openBox('create')">创建</el-button>
        <el-button icon="el-icon-delete" v-if="showBtn[2].isShow" type="danger" @click="deleteDate('ncldlzyjyhcyb')">删除</el-button>
        <el-button style="padding: 0" v-if="showBtn[4].isShow"><file_Upload :_url="$public.upload_url._x"></file_Upload></el-button>
        <el-button type="primary" @click="downShow = true" icon="el-icon-document-remove">下载模板</el-button>
        <el-button type="primary" v-if="showBtn[5].isShow" v-loading.fullscreen.lock="lodaingTime" @click="Filter_export(`${api}/export`,form)" icon="el-icon-document-remove">导出数据</el-button>
    </div>
    <div class="table">
      <el-table :data="tableData" border max-height="550" @selection-change="handleSelectionChange" style="width: 99.9%">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column show-overflow-tooltip v-for="(item,index) in baseInfo" :key="index" :prop="item.key" fixed :label="item.value" align="center"></el-table-column>
        <el-table-column show-overflow-tooltip label="农村劳动力转移就业" align="center">
          <el-table-column show-overflow-tooltip label="总人数" prop="transferTotalCount" align="center"></el-table-column>
          <el-table-column show-overflow-tooltip prop='transferAddJobPersons' label="新增转移就业人数" align="center"></el-table-column>
          <el-table-column show-overflow-tooltip prop='newJobPerson' label="初次转移就业" align="center"></el-table-column>
          <el-table-column show-overflow-tooltip prop='transferAgain' label="再次转移就业" align="center"></el-table-column>
          <el-table-column show-overflow-tooltip prop='transferFemale' label="女性" align="center"></el-table-column>
          <el-table-column show-overflow-tooltip prop='transferTrainingCount' label="已参加培训人数" align="center"></el-table-column>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="年龄分布" align="center">
            <el-table-column show-overflow-tooltip prop='ageRange16to20' label="16至20岁" align="center"></el-table-column>
            <el-table-column show-overflow-tooltip prop='ageRange21to30' label="21至30" align="center"></el-table-column>
            <el-table-column show-overflow-tooltip prop='ageRange31to45' label="31至45" align="center"></el-table-column>
            <el-table-column show-overflow-tooltip prop='ageRange46to60' label="46至60" align="center"></el-table-column>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="文化程度" align="center">
          <el-table-column show-overflow-tooltip prop='middleSchool' label="初中及以下" align="center"></el-table-column>
          <el-table-column show-overflow-tooltip prop='highSchool' label="高中及中职类" align="center"></el-table-column>
          <el-table-column show-overflow-tooltip prop='university' label="大专及以上" align="center"></el-table-column>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="转移就业地域分布" align="center">
          <el-table-column show-overflow-tooltip label="省外就业人数" prop="provinceOut" align="center"></el-table-column>
          <el-table-column show-overflow-tooltip prop='zhu3River' label="珠三角地区" align="center"></el-table-column>
          <el-table-column show-overflow-tooltip prop='long3River' label="长三角地区" align="center"></el-table-column>
          <el-table-column show-overflow-tooltip prop='jjArea' label="京津地区" align="center"></el-table-column>
          <el-table-column show-overflow-tooltip prop='otherArea' label="其它地区" align="center"></el-table-column>
          <el-table-column show-overflow-tooltip prop="provinceIn" label="省内就业人数" align="center"></el-table-column>
          <el-table-column show-overflow-tooltip prop='localhost' label="本地就业人数" align="center"></el-table-column>
          <el-table-column show-overflow-tooltip prop='outside' label="境外就业人数" align="center"></el-table-column>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="农民工创业情况" align="center">
          <el-table-column show-overflow-tooltip prop="pioneer" label="创业总人数" align="center"></el-table-column>
          <el-table-column show-overflow-tooltip prop='comeBack' label="回乡创业人数" align="center"></el-table-column>
          <el-table-column show-overflow-tooltip prop='realEntityCount' label="创办经济实体个数" align="center"></el-table-column>
          <el-table-column show-overflow-tooltip prop='helpFromPioneer' label="创业带动就业人数" align="center"></el-table-column>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop='month' label="导入时间" align="center"></el-table-column>
      </el-table>
      <paging :pagesData="$data.paging_data" @set_page_number = 'get_page_number'></paging>
    </div>
    <!-- 模态框 -->
    <el-dialog title="农村劳动力转移就业和创业情况表" :visible.sync="centerDialogVisible" @close="close" :modal="false" width="1400px" :close-on-click-modal="false" center>
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">基本信息</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" :rules="rules" ref="editForm" size="mini" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="地区：">
                          <!-- <Area :value="area_data" :name="arrPlace" @getPlace="getPlace"/> -->
                          <Area :value="area_data" :diss="dis" :name="arrPlace" @getPlace="getPlace"/>
                        </el-form-item>
                        <el-form-item label="- 农村劳动力转移就业 -"></el-form-item>
                        <el-form-item label="总人数：">
                          <el-input style="width:193px;" v-model="editForm.transferTotalCount"></el-input>
                        </el-form-item>
                        <el-form-item label="新增转移就业人数：">
                          <el-input style="width:193px;" v-model="editForm.transferAddJobPersons"></el-input>
                        </el-form-item>
                        <el-form-item label="初次转移就业：">
                          <el-input style="width:193px;" v-model="editForm.newJobPerson"></el-input>
                        </el-form-item>
                        <el-form-item label="再次转移就业：">
                          <el-input style="width:193px;" v-model="editForm.transferAgain"></el-input>
                        </el-form-item>
                        <el-form-item label="女性：">
                          <el-input style="width:193px;" v-model="editForm.transferFemale"></el-input>
                        </el-form-item>
                        <el-form-item label="已参加培训人数：">
                          <el-input style="width:193px;" v-model="editForm.transferTrainingCount"></el-input>
                        </el-form-item>
                        <el-form-item label="- 年龄分布 -"></el-form-item>
                        <el-form-item label="16至20岁：">
                          <el-input style="width:193px;" v-model="editForm.ageRange16to20"></el-input>
                        </el-form-item>
                        <el-form-item label="21至30岁：">
                          <el-input style="width:193px;" v-model="editForm.ageRange21to30"></el-input>
                        </el-form-item>
                        <el-form-item label="31至45岁：">
                          <el-input style="width:193px;" v-model="editForm.ageRange31to45"></el-input>
                        </el-form-item>
                        <el-form-item label="46至60岁：">
                          <el-input style="width:193px;" v-model="editForm.ageRange46to60"></el-input>
                        </el-form-item>
                        <el-form-item label="- 文化程度 -"></el-form-item>
                        <el-form-item label="初中及以下：">
                          <el-input style="width:193px;" v-model="editForm.middleSchool"></el-input>
                        </el-form-item>
                        <el-form-item label="高中及中职类：">
                          <el-input style="width:193px;" v-model="editForm.highSchool"></el-input>
                        </el-form-item>
                        <el-form-item label="大专及以上：">
                          <el-input style="width:193px;" v-model="editForm.university"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="- 转移就业地域分布 -"></el-form-item>
                        <el-form-item label="省外就业人数：">
                          <el-input style="width:193px;" v-model="editForm.provinceOut"></el-input>
                        </el-form-item>
                        <el-form-item label="珠三角地区：">
                          <el-input style="width:193px;" v-model="editForm.zhu3River"></el-input>
                        </el-form-item>
                        <el-form-item label="长三角地区：">
                          <el-input style="width:193px;" v-model="editForm.long3River"></el-input>
                        </el-form-item>
                        <el-form-item label="京津地区：">
                          <el-input style="width:193px;" v-model="editForm.jjArea"></el-input>
                        </el-form-item>
                        <el-form-item label="其它地区：">
                          <el-input style="width:193px;" v-model="editForm.otherArea"></el-input>
                        </el-form-item>
                        <el-form-item label="省内就业人数：">
                          <el-input style="width:193px;" v-model="editForm.provinceIn"></el-input>
                        </el-form-item>
                        <el-form-item label="本地就业人数：">
                          <el-input style="width:193px;" v-model="editForm.localhost"></el-input>
                        </el-form-item>
                        <el-form-item label="境外就业人数：">
                          <el-input style="width:193px;" v-model="editForm.outside"></el-input>
                        </el-form-item>
                        <el-form-item label="- 农民工创业情况 -"></el-form-item>
                        <el-form-item label="创业总人数">
                          <el-input style="width:193px;" v-model="editForm.pioneer"></el-input>
                        </el-form-item>
                        <el-form-item label="回乡创业人数">
                          <el-input style="width:193px;" v-model="editForm.comeBack"></el-input>
                        </el-form-item>
                        <el-form-item label="创办经济实体个数">
                          <el-input style="width:193px;" v-model="editForm.realEntityCount"></el-input>
                        </el-form-item>
                        <el-form-item label="创业带动就业人数">
                          <el-input style="width:193px;" v-model="editForm.helpFromPioneer"></el-input>
                        </el-form-item>
                        <el-form-item label="导入时间：">
                          <el-date-picker style="width:193px;" value-format="yyyy-MM" v-model="editForm.month" type="date" placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
    <dowmloadplace :value="type" :downShow="downShow" @cutOff="cutOff"/>
  </div>
</template>

<script>
import mixins from '@/Mixins'
export default {
  mixins: [mixins],
  data() {
    return{
      api: '/user/transferJob',
      form: {},
      type: '11',
      centerDialogVisible: false,
      tableData: [],
      selectRow: [],
      baseInfo: [
        {key: 'province', value: '省'},
        {key: 'city', value: '市'},
        {key: 'county', value: '县'},
        {key: 'town', value: '镇'},
        {key: 'village', value: '村'},
      ],
      rules:{
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { min: 18, max: 18, message: '长度为18个字符', trigger: 'blur' }
        ],
      },
      isCreate:false,
    }
  },
  methods:{
    handleSelectionChange(val) {
      this.selectRow = val
    },
    //分页
    get_page_number(pageNumer) {
      let [vm] = [this]
      vm.form.pageNumber = pageNumer;
      vm.Filter_file({api:vm.api,data:vm.form,callback:_d => vm.tableData = _d})
    },
    //提交请求
    submit() {
      let newForm = {}
      newForm = JSON.parse(JSON.stringify(this.editForm))
      delete newForm.areaId
      
      newForm.province = this.province
      newForm.city = this.city
      newForm.county = this.county
      newForm.town = this.town
      newForm.village = this.village
      this.$refs['editForm'].validate((valid)=>{
        if (valid && this.isCreate === true) {
          this.$api.create(this.api,newForm).then(res =>{
            if (res.data.status === 0) {
              this.$message.success('创建成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else{
							this._status(res.data)
						}
          })
        } else if (valid && this.isCreate === false) {
          delete newForm.createTime
          this.$api.change(`${this.api}/modify`,newForm).then(res =>{
            if (res.data.status === 0) {
              this.$message.success('修改成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else{
							this._status(res.data)
						}
          })
        } else {
          return false
        }
      })
    },
  },
  created() {
    this.isShowBtn("TransferJob")//控制操作按钮的显示与隐藏
    this.getArea({value:{areaId:0},key:0})
  },
}
</script>

<style lang="scss" scoped>
/* .index .index-header .el-form-item__content{width: 200px;} */
.input-box>div{display: flex;flex-direction: column;flex-shrink: 0;}
</style>